export default "__VITE_ASSET__udTL8LJ4__"